import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placement-process',
  templateUrl: './placement-process.component.html',
  styleUrls: ['./placement-process.component.scss']
})
export class PlacementProcessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
